export default {
	home: 'Homepage',
	contact: 'Contact',
	dummyData: 'Dummy data',
};
